// eslint-disable-next-line import/no-cycle
import request from '@/utils/request'

/**
 * @apiName 获取应收管理列表
 * @apiUrl
 */
export function getReceivableList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取应收管理列表(ES专用)
 * @apiUrl
 */
export function getReceivableByESList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/esList',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 获取应收管理列表 - (包含table头部信息)
 * @apiUrl
 */
export function getReceivableListWithHeaderInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/receivableList',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取账户类型
 * @apiUrl
 */
export function getAccountType(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/account/summary',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取账户列表
 * @apiUrl
 */
export function getAccountList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/account/list',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 更新用户账户状态
 * @apiUrl
 */
export function updateState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/account/updateState',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 新增用户接口（付款账号、收款账号）
 * @apiUrl
 */
export function addAccount(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/account/add',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 编辑用户接口
 * @apiUrl
 */
export function updateAccount(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/account/update',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 收款方查询接口（服务商列表查询接口，1维修厂）
 * @apiUrl
 */
export function getCollectCustomerList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 应付列表查询
 * @apiUrl
 */
export function getPaymentList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 应付列表脱敏查询
 */
export function getSensitivePaymentList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/list/sensitive',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 应付列表查询 - (包含table头部信息)
 * @apiUrl
 */
export function getPaymentListWithHeaderInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/paymentList',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取应收详情
 * @apiUrl
 */
export function getReceivableDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/detail',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取脱敏应收详情
 */
export function getSensitiveReceivableDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/detail/sensitive',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 新增应收
 * @apiUrl
 */
export function addReceivable(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/v3/add',
    method: 'POST',
    data,
    signParams: [
      'body.sourceOrderId',
      'body.sourceOrderType',
      'body.receivableAmount',
      'body.receivedAmount',
    ],
  })
}

/**
 * @apiName 新增应付
 * @apiUrl
 */
export function addPayment(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/v3/add',
    method: 'POST',
    data,
    signParams: [
      'body.sourceOrderId',
      'body.sourceOrderType',
      'body.payAmount',
      'body.paidAmount',
    ],
  })
}


/**
 * @apiName 新增收款单
 * @apiUrl
 */
export function addReceiptSignCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/receipt/v3/add',
    method: 'POST',
    data,
    signParams: [
      'body.receivableId',
      'body.receivableType',
      'body.amount',
      'body.payMethod',
    ],
  })
}

/**
 * @apiName 收款单列表查询
 * @apiUrl
 */
export function getReceiptList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/receipt/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 收款单收款方式
 * @apiUrl
 */
export function getCollectionPayMethod(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/account/type',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取收款单详情
 * @apiUrl
 */
export function getReceiptDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/receipt/detail',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 编辑收款单
 * @apiUrl
 */
export function editReceipt(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/receipt/update',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取付款单列表
 * @apiUrl
 */
export function getPaymentOrderList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/bill/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取付款单详情
 * @apiUrl
 */
export function getPaymentOrderDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/bill/detail',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 新增付款单
 * @apiUrl
 */
export function addPaymentOrderSignCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/bill/v3/add',
    method: 'POST',
    data,
    signParams: [
      'body.paymentId',
      'body.amount',
    ],
  })
}

/**
 * @apiName 编辑付款单
 * @apiUrl
 */
export function editPaymentOrder(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/bill/update',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 修改应收单号状态
 * @apiUrl
 */
export function updateCollectionState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/state',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 关闭应收前检查接口
 * @apiUrl
 */
export function closeCollectionCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/checkBeforeUpdateState',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 修改应付单号状态
 * @apiUrl
 */
export function updatePayState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/state',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 查看应付单详情
 * @apiUrl
 */
export function getPaymentDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/detail',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 查看脱敏应付单详情
 */
export function getSensitivePaymentDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/detail/sensitive',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 批量收款列表&订单收款列表
 * @apiUrl
 */
export function getbatchCollectionRecordList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/record/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 批量脱敏收款列表&订单收款列表
 * @apiUrl
 */
export function getBatchCollectionRecordListSensitive(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/record/list/sensitive',
    method: 'POST',
    data,
  })
}

// 批量收款记录撤回
export function batchRecordRetract(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTask/revoke',
    // url: '/admin/v1/vehicle/finance/batch/receivable/record/retract',
    method: 'POST',
    data,
  })
}

export function getReceivableStatistic(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/statistic',
    method: 'POST',
    data,
  })
}

/**
 * @apiName getReceivableStatistic By ES
 * @apiUrl
 */
export function getReceivableByESStatistic(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/esStatistic',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 批量付款列表
 * @apiUrl
 */
export function getbatchPaymentRecordList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/record/list',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 批量收款添加
 * @apiUrl
 */
export function getbatchCollectionRecordAddSignCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/record/v2/add',
    method: 'POST',
    data,
    signParams: ['customerType', 'customerId', 'totalAmount', 'paymentId', 'amount'],
  })
}

/**
 * @apiName 批量收款详情
 * @apiUrl
 */
export function getbatchCollectionRecordDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/record/detail',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 批量付款详情
 * @apiUrl
 */
export function getbatchPaymentRecordDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/record/detail',
    method: 'POST',
    data,
  })
}

// 应收变更
export function receivableChangeReceivable(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/changeReceivable',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 批量收款单列表  无文件中使用
 * @apiUrl
 */
export function getbatchOrderList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/order/list',
    method: 'POST',
    data,
  })
}
// 应付变更
export function paymentChangePaymentSignCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/v3/changePayment',
    method: 'POST',
    data,
    signParams: [
      'body.id',
      'body.payAmount',
    ],
  })
}
/**
 * @apiName 批量付款单列表
 * @apiUrl
 */
export function getbatchPayOrderList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/order/list',
    method: 'POST',
    data,
  })
}
// 收款单作废
export function receivableReceiptCancel(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/receipt/cancel',
    method: 'POST',
    data,
  })
}
// 收款单作废前检查接口
export function receivableReceiptCancelCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/receipt/checkBeforeCancel',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 类目管理
 * @apiUrl
 */
export function getCategoryManage(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/category/list',
    method: 'POST',
    data,
  })
}

// 付款单作废
export function paymentBillCancel(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/bill/cancel',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 新增类目
 * @apiUrl
 */
export function getCategoryAdd(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/category/add',
    method: 'POST',
    data,
  })
}
// 付款单列表统计
export function paymentBillStatistic(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/bill/statistic',
    method: 'POST',
    data,
  })
}
// 财务类目编辑
export function editCategory(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/category/edit',
    method: 'POST',
    data,
  })
}

// 收款单列表统计
export function receivableReceiptStatistic(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/receipt/statistic',
    method: 'POST',
    data,
  })
}

// 退款单金额统计
export function receivableRefundStatistic(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/refund/receipt/statistic',
    method: 'POST',
    data,
  })
}

// 批量付款单列表分页查询
export function getBatchPaymentOrderPageList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/order/pageList',
    method: 'POST',
    data,
  })
}

// 批量收款单列表查询
export function getBatchReceivableOrderList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/order/list',
    method: 'POST',
    data,
  })
}

// 分页批量收款单列表查询
export function getBatchReceivableOrderPageList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/order/pageList',
    method: 'POST',
    data,
  })
}

// 批量付款记录作废
export function batchPaymentRecordDiscard(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/record/discard',
    method: 'POST',
    data,
  })
}

// 批量收款记录作废
export function batchReceivableRecordDiscard(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/record/discard',
    method: 'POST',
    data,
  })
}

// 应付列表统计
export function getPaymentStatistic(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/statistic',
    method: 'POST',
    data,
  })
}


// 出入库记录
export function stockList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/stockList',
    method: 'POST',
    data,
  })
}

// 订单关联信息
export function relationList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/relation/record/relationList',
    method: 'POST',
    data,
  })
}

// 脱敏订单关联信息
export function getRelationList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/relation/record/relationList/sensitive',
    method: 'POST',
    data,
  })
}

// 订单退车结算信息
export function vehiclesettlement(data = {}) {
  return request({
    url: '/admin/v1/vehicle/order/returnCar/settlementInfo',
    method: 'POST',
    data,
  })
}

// 批量调整应收
export function setBatchReceivable(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/changeReceivable/import',
    method: 'POST',
    data,
  })
}

// 查询导入的数据
export function getBatchReceivableList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/changeReceivable/getImportList',
    method: 'POST',
    data,
  })
}

// 线上批量收款新增
export function batchReceivableOnlineCreate(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/online/create',
    method: 'POST',
    data,
  })
}

// 确认调整
export function changeReceivableConfirm(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/changeReceivable/confirm',
    method: 'POST',
    data,
  })
}

// 线上批量收款详情
export function getBatchReceivableOnlineDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/online/detail',
    method: 'POST',
    data,
  })
}

// 获取支付宝支付配置
export function getAlipayConfig(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/config/alipay/get',
    method: 'POST',
    data,
  })
}

// 上传支付宝定时支付配置
export function postAlipayConfig(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/config/alipay/update',
    method: 'POST',
    data,
  })
}

// 创建支付宝支付收款单
export function addAlipayReceipt(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/receipt/alipay/add',
    method: 'POST',
    data,
  })
}

// 创建退款单
export function addRefund(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/refund/receipt/add',
    method: 'POST',
    data,
  })
}

// 获取退款单列表
export function getRefundList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/refund/receipt/list',
    method: 'POST',
    data,
  })
}

// 获取扣款计划列表
export function getAccruedPlanList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/accruedPlan/list',
    method: 'POST',
    data,
  })
}
// 终止扣款计划
export function abortAccruedPlan(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/accruedPlan/abort',
    method: 'POST',
    data,
  })
}

// 获取应收款项列表
export function getCollectionRecordList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/batchSelect',
    method: 'POST',
    data,
  })
}

// 应收预览接口
export function receivableAccruedPreview(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/accruedPreview/receivable',
    method: 'POST',
    data,
  })
}
// 删除单个应计id
export function removeAccruedPreview(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/accruedPreview/remove',
    method: 'POST',
    data,
  })
}

// 撤回审批
export function withdrawApproval(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTask/revoke',
    // url: '/admin/v1/vehicle/finance/batch/receivable/record/retract',
    method: 'POST',
    data,
  })
}

// 生成扣款计划
export function addAccruedPlan(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/accruedPlan/add',
    method: 'POST',
    data,
  })
}

// 确认变更减免金额
export function addReceivableConfirmSignCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/v3/changeRelieve',
    method: 'POST',
    data,
    signParams: [
      'body.id',
      'body.relieveAmount',
    ],
  })
}

// 批量减免金额
export function receivableChangeRelieveImport(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/changeRelieve/import',
    method: 'POST',
    data,
  })
}

// 查看导入列表
export function receivableChangeRelieveGetImportList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/changeRelieve/getImportList',
    method: 'POST',
    data,
  })
}

// 批量减免导入提交
export function receivableConfirm(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/changeRelieve/confirm',
    method: 'POST',
    data,
  })
}

// 审批通过或是驳回 - 合并代码后先注释，若有问题再打开
// export function approvalOperation (data = {}) {
//   return request({
//     url: '/admin/v1/vehicle/approvalTask/submit',
//     method: 'POST',
//     data
//   })
// }

// 发起结算：确认新增
export function accidentSettlementAddSignCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/routines/accident/settlement/v3/add',
    method: 'POST',
    data,
    signParams: [
      'body.accidentId',
      'body.receivableAmount',
    ],
  })
}

// 部分圈选添加至预览
export function batchReceivablePartPreview(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/part/previewAdd',
    method: 'POST',
    data,
  })
}

// 新增全部数据至预览
export function batchReceivableAllPreview(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/all/previewAdd',
    method: 'POST',
    data,
  })
}

// 预览接口
export function batchReceivablePreview(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/preview',
    method: 'POST',
    data,
  })
}

// 移除单个未完成的应收
export function batchReceivableRemove(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/batchReceivable/remove',
    method: 'POST',
    data,
  })
}

// 款项分摊
export function batchReceivableSplitFeeSignCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/v3/splitFee',
    method: 'POST',
    data,
    signParams: [
      'body.previewId',
      'body.totalAmount',
    ],
  })
}

// 一键设置未完成收款类目
export function setReceivableCategory(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/category/update',
    method: 'POST',
    data,
  })
}

// 本次收款金额更改
export function batchReceivableSetFieldValue(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/setFieldValue',
    method: 'POST',
    data,
  })
}
// 校验应收记录批量调整有无审核中的数据
export function receivableFilterReceivable(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/filterReceivable',
    method: 'POST',
    data,
  })
}
// 批量付款-添加相关未完成应付-新增全部数据至预览
export function paymentAllPreviewAdd(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/all/previewAdd',
    method: 'POST',
    data,
  })
}

// 批量付款-添加相关未完成应付-确认新增（选中部分接口）
export function paymentPartPreviewAdd(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/part/previewAdd',
    method: 'POST',
    data,
  })
}
// 批量付款-选中的相关未完成应付数据
export function paymentPreview(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/preview',
    method: 'POST',
    data,
  })
}

// 批量付款-更新已添加应付表格中某一条的【本次收款金额】
export function paymentSetFieldValue(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/setFieldValue',
    method: 'POST',
    data,
  })
}

// 基于车辆ID和来源单类型获取来源单ID集合
export function getSourceOrderId(data = {}) {
  return request({
    url: '/admin/v1/vehicle/common/getSourceOrderId',
    method: 'POST',
    data,
  })
}

// 应付款项分摊接口
export function paymentSplitFeeSignCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/v3/splitFee',
    method: 'POST',
    data,
    signParams: [
      'body.previewId',
      'body.totalAmount',
    ],
  })
}

// 上传收款单明细 批量线下收款
export function createReceivableList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/record/create',
    method: 'POST',
    data,
  })
}

// 上传付款单明细 批量线下付款
export function createPaymentList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/record/v3/create',
    method: 'POST',
    data,
    signParams: [
      'body.paymentOrderExcelUrl',
      'body.remarks',
    ],
  })
}

// 获取收款主体列表
export function getMerchantListAPI(data = {}) {
  return request({
    url: '/admin/v1/superviseAccount/merchant/list',
    method: 'POST',
    data,
  })
}

// 获取网约SP列表
export function getSpListAPI(data = {}) {
  return request({
    url: '/admin/v1/superviseAccount/sp/list',
    method: 'POST',
    data,
  })
}
